module.exports = __webpack_public_path__ + "media/svg/mt-5fbb4941.svg";